import { render, staticRenderFns } from "./Hero.vue?vue&type=template&id=5c56f22c&scoped=true"
import script from "./Hero.vue?vue&type=script&lang=ts"
export * from "./Hero.vue?vue&type=script&lang=ts"
import style0 from "./Hero.vue?vue&type=style&index=0&id=5c56f22c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c56f22c",
  null
  
)

export default component.exports